<template>
    <v-container fluid>
        <v-card class="soli-round">
            <v-container fluid>
                <v-card-title class="header soli-grey"
                    >Enrollments</v-card-title
                >
                <v-data-table
                    :items="enrollments"
                    :headers="headers"
                    groupBy="user.id"
                    mobile-breakpoint="0"
                    hide-default-footer
                    disable-pagination
                >
                    <template
                        v-slot:[`group.header`]="{
                            group,
                            items,
                            isOpen,
                            toggle,
                        }"
                    >
                        <th colspan="15">
                            <div class="flex justify-start align-center gap-6">
                                <v-icon @click="toggle"
                                    >{{ isOpen ? "remove" : "add" }}
                                </v-icon>
                                <div
                                    class="soli-grey font-weight-bold"
                                    style="font-size: 14px"
                                >
                                    {{ items[0].user.name }}
                                </div>
                            </div>
                        </th>
                    </template></v-data-table
                ></v-container
            >
        </v-card>
    </v-container>
</template>

<script>
export default {
    props: {
        enrollments: {
            type: Array,
            default: () => [],
        },
    },
    data() {
        return {
            headers: [
                { text: "ID", value: "id" },
                {
                    text: "Student",
                    value: "user.name",
                    class: "hide",
                    cellClass: "hide",
                },
                { text: "Start", value: "starts_at", width: "120px" },
                { text: "End", value: "ends_at", width: "120px" },
                { text: "Teacher", value: "teacher.name", width: "180px" },
                { text: "Program", value: "program.title", width: "140px" },
                { text: "Location", value: "location.name" },
                { text: "Instrument", value: "instrument.name" },
                { text: "Group Event", value: "groupEvent.title" },
                { text: "Price", value: "price.formatAmount" },
                { text: "Duration", value: "duration" },
                { text: "Enrollment Gap", value: "enrollment_gap" },
                { text: "Location Teacher Gap", value: "location_teacher_gap" },
                {
                    text: "Location Teacher Enrollment",
                    value: "location_teacher_enrollment",
                },

                /*{ text: "Teacher Gap", value: "teacher_gap" },
                { text: "Location Gap", value: "location_gap" },
                { text: "Instrument Gap", value: "instrument_gap" },
                { text: "Program Gap", value: "program_gap" },*/
            ],
        };
    },
};
</script>
